import type { Asset } from '@mentimeter/content-contentful/legacy/types/generated/contentful';

export const getContentfulAssetImageProps = (image: Asset) => ({
  src: image.fields?.file.url,
  ...image.fields?.file.details.image,
});
